import MapActions from '../enums/ActionTypes/MapActions'
import {OnClickAction} from '../enums/MapEvents'
import {setCookie} from '../helpers'
import {IPaylodAction} from '../interfaces/dispatchers'
import {IMap} from '../interfaces/reducers'
import {IMapService} from '../interfaces/services'

const initState = {
  onClickAction: OnClickAction.IdentifyToTables,
  zoom: 0,
  extent: {},
  visibleLayers: {},
  basemap: '',
  sourcesImported: false,
  hardLoading: false
} as any
let stateSnapShot: Readonly<IMap> = {} as Readonly<IMap>

const map = (state = initState, action: IPaylodAction) => {
  switch (action.type) {
    case MapActions.ADD_MAP_MANAGER:
      stateSnapShot = {...state, mapService: action.payload}
      break

    case MapActions.SET_BASEMAP:
      stateSnapShot = {...state, basemap: action.payload}
      break
    case MapActions.SOURCES_IMPORTED:
      stateSnapShot = {...state, sourcesImported: action.payload}
      break
    case MapActions.EXTENT_CHANGED:
      setCookie('zoom', JSON.stringify(action.payload.zoom), 365)
      setCookie('center', JSON.stringify([action.payload.centerX, action.payload.centerY]), 365)
      stateSnapShot = {
        ...state,
        extent: action.payload.extent,
        zoom: action.payload.zoom
      }
      break
    case MapActions.DISABLE_ONCLICK:
      stateSnapShot = {
        ...state,
        onClickDisabled: true
      }
      break
    case MapActions.SET_POPUP_PROPERTIES:
      stateSnapShot = {
        ...state,
        popup: {...action.payload}
      }
      break
    case MapActions.SET_HARD_LOADING:
      stateSnapShot = {
        ...state,
        hardLoading: action.payload
      }
      break
    case MapActions.ENABLE_ONCLICK:
      stateSnapShot = {
        ...state,
        onClickDisabled: false
      }
      break
    case MapActions.CHANGE_ONCLICK_ACTION:
      stateSnapShot = {
        ...state,
        onClickAction: action.payload
      }
      break
    default:
      stateSnapShot = {...state}
      break
  }
  if (!stateSnapShot.popup) {
    stateSnapShot = {
      ...stateSnapShot,
      popup: {
        show: false,
        coordinates: [0, 0],
        maximized: false,
        selectedPage: 0,
        loading: false
      }
    }
  }
  return stateSnapShot
}
;(window as any).gmap = () => {
  return stateSnapShot
}
export default map

export const getMapService = (): IMapService => {
  return stateSnapShot.mapService
}
